export class Announcement {
    id!: number;
    title!: string;
    text!: string;
    created_at!: string;
    created_at_date!: Date;

    static fromObject(obj: Record<string, any>): Announcement {
        const announcement = Object.setPrototypeOf(obj, Announcement.prototype);
        announcement.created_at_date = new Date(announcement.created_at);
        return announcement;
    }
}
